// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.getContent_title__SXKWJ {
  font-weight: 600;
  font-size: 3rem;
  padding-top: 1rem;
  word-wrap: break-word; /* Ngắt dòng khi cần */
  word-break: break-word; /* Hỗ trợ các từ dài */
  overflow-wrap: break-word; /* Thêm tùy chọn cho các trình duyệt khác */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  margin-top: 50px;
}

.getContent_content__1NnDL {
  min-height: 50vh;
  font-size: 2rem !important;
  text-align: justify; /* Căn đều hai bên */
}

.getContent_comment__ieJJW {
  padding-top: 100px;
}

@media (max-width: 768px) {
  img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */
  }
  .getContent_title__SXKWJ {
    width: 80%;
    font-size: 2.4rem;
  }
}
@media (min-width: 769px) and (max-width: 1200px) {
  img {
    width: 80%;
    height: 100%;
    object-fit: contain; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */
  }
  .getContent_title__SXKWJ {
    width: 90%;
    font-size: 2.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/content/post/getItem/getContent/getContent.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA,EAAA,sBAAA;EACA,sBAAA,EAAA,sBAAA;EACA,yBAAA,EAAA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AACJ;;AACA;EACI,gBAAA;EACA,0BAAA;EACA,mBAAA,EAAA,oBAAA;AAEJ;;AAAA;EACI,kBAAA;AAGJ;;AADA;EACI;IACE,WAAA;IACA,YAAA;IACA,iBAAA,EAAA,6DAAA;EAIJ;EAFE;IACE,UAAA;IACA,iBAAA;EAIJ;AACF;AAFA;EACI;IACI,UAAA;IACA,YAAA;IACA,mBAAA,EAAA,6DAAA;EAIN;EAFI;IACE,UAAA;IACA,iBAAA;EAIN;AACF","sourcesContent":["\n.title{\n    font-weight: 600;\n    font-size: 3rem;\n    padding-top: 1rem;\n    word-wrap: break-word; /* Ngắt dòng khi cần */\n    word-break: break-word; /* Hỗ trợ các từ dài */\n    overflow-wrap: break-word; /* Thêm tùy chọn cho các trình duyệt khác */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 70%;\n    margin-top: 50px;\n}\n.content {\n    min-height: 50vh ;\n    font-size: 2rem !important;\n    text-align: justify; /* Căn đều hai bên */\n}\n.comment{\n    padding-top: 100px;\n}\n@media (max-width: 768px) {\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */\n    }\n    .title{\n      width: 80%;\n      font-size: 2.4rem;\n    }\n  }\n@media (min-width: 769px) and (max-width: 1200px){\n    img {\n        width: 80%;\n        height: 100%;\n        object-fit: contain; /* Có thể thay bằng 'contain' nếu muốn toàn bộ ảnh hiển thị */\n      }\n      .title{\n        width: 90%;\n        font-size: 2.4rem;\n      }\n\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `getContent_title__SXKWJ`,
	"content": `getContent_content__1NnDL`,
	"comment": `getContent_comment__ieJJW`
};
export default ___CSS_LOADER_EXPORT___;
